import React from "react";
import "./SellerHome.scss";
import HeadingTag from "../../component/heading-tag/HeadingTag";
import { LuCheckCheck } from "react-icons/lu";
import rohit from "../../assets/testimonial/rohhhit.jpg";
import sneha from "../../assets/testimonial/sneha.jpg";
import saurabh from "../../assets/testimonial/saurabh.jpg";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import step_img1 from "../../assets/steps/2114.jpg";
import care from "../../assets/seller-benefits/commerce.gif";
import earn from "../../assets/seller-benefits/earn-money.gif";
import voice from "../../assets/seller-benefits/voice-command.gif";
import handholding from "../../assets/seller-benefits/customer-care.gif";
import { GoCheck } from "react-icons/go";
import product_listing from "../../assets/online_business/product_listing.png";
import marketing_tool from "../../assets/online_business/marketing_tool.png";
import strategy from "../../assets/online_business/strategy.png";
import { TiArrowForward } from "react-icons/ti";
import hero_video from "../../assets/gif&videos/seller_hero_section.webm"
import ReactPlayer from "react-player";
import marketing from "../../assets/why_choose_us/megaphone.png"
import analysis from "../../assets/why_choose_us/analysiscolor.png"
import support from "../../assets/why_choose_us/support.png"
import { Link } from "react-router-dom";
import register from "../../assets/steps/register.jpg";
import addtoproducts from "../../assets/steps/ad_to_products.jpg";
import dashboard from "../../assets/steps/dashboard.jpg";
import track from "../../assets/steps/track.jpg";


function SellerHome(props) {
  //why choose us data
  const w_c_data = [
    {
      logo: <GoCheck />,
      heading: "Social Impact",
      des: "We uplift rural communities by giving them a direct market",
    },
    {
      logo: <GoCheck />,
      heading: "Sustainable Growth",
      des: "Our platform decentralizes power, ensuring fair opportunities",
    },
    {
      logo: <GoCheck />,
      heading: "Jan kalyan",
      des: "We support rural and Adivasi sellers through educational and meaningful, heartfelt well-being initiatives.",
    },
    {
      logo: <GoCheck />,
      heading: "Low Commission, High Transparency",
      des: "Fair pricing with no hidden costs",
    },
    {
      logo: <GoCheck />,
      heading: "Marketing & Visibility",
      des: "Dedicated promotion for small sellers and artisans",
    },
    {
      logo: <GoCheck />,
      heading: "Logistics & Support",
      des: " Hassle-free shipping and fulfillment services",
    },
  ];

  // testimonial data
  const testimonial_data = [
    {
      icon: <LuCheckCheck />,
      des: "Amazing service! Loved the local touch and quick delivery. Will definitely order again!",
      image: saurabh,
      name: "Saurabh Jadhav",
      city: "Maharastra, Pune",
    },
    {
      icon: <LuCheckCheck />,
      des: "Jungleboosh brings authentic Maharashtra vibes to my doorstep. Truly a delightful experience!",
      image: sneha,
      name: "Sneha Patil",
      city: "Maharastra, Nashik",
    },
    {
      icon: <LuCheckCheck />,
      des: "Great quality products and timely support. Jungleboosh is my new favorite platform!",
      image: rohit,
      name: "Rohit Deshmukh",
      city: "Maharastra, Kolhapur",
    },
  ];

  // steps data
  const steps_data = [
    {
      step_image: register,
      step_name: "Create Your Account",
      steps_contain:
        "Log in to the Jungle Boosh web app and sign up with your basic details. It’s simple, fast, and made for everyone.",
    },
    {
      step_image: addtoproducts,
      step_name: "Add Your Products",
      steps_contain:
        "Upload photos, videos, and details of what you create—farming goods, handmade items, or anything local. Show the world your work.",
    },
    {
      step_image: dashboard,
      step_name: "Go Live and Start Selling",
      steps_contain:
        "Once you register your products, they’ll appear on our website where people across cities and countries can buy directly from you.",
    },
    {
      step_image: track,
      step_name: "Track Your Orders & Grow",
      steps_contain:
        "Monitor your sales and keep track of orders in our easy-to-use selling panel. Stay updated, manage your inventory, and grow your business with Jungle Bush.",
    },
  ];

  //seller benefits
  const seller_benefits_data = [
    {
      heading: "Earn with Dignity",
      desc: "A platform that respects your work, culture, and the value you bring.",
      img: earn,
    },
    {
      heading: "Handholding Support",
      desc: "Whether it’s logistics or listings, we’re here to guide you at every step.",
      img: handholding,
    },
    {
      heading: "Voice & Visibility",
      desc: "Share your story, reach new buyers, and grow your identity.",
      img: voice,
    },
    {
      heading: "Care Beyond Commerce",
      desc: "We support your journey — from education to well-being — with love and intent.",
      img: care,
    },
  ];

  return (
    <>
      {/* header */}
      <Header />

      {/* seller panel */}
      <div className="parent seller-home-parent ">
        <div class="border"></div>
        <div className="cont seller-home-container">
          <div className="seller-home-left">
            <h1>
              Start Your <span>Journey</span> from Soil to Sky with <span>Jungle Boosh</span>
            </h1>
            <p>
              Jungle Boosh helps local sailors and creators take their work from the village to the world. Your journey starts here — from soil to sky, we’re with you every step.
            </p>
            <Link to="/register" target="blank" className="btn">Start Selling</Link>
          </div>
          {/* <div class="bullet"></div> */}
          <div className="seller-home-right bg-img-cover">
            <ReactPlayer
              url={hero_video}
              height="100%"
              width="100%"
              className="react-video"
              playing={true} // Corrected from autoplay to playing
              loop={true}
              inline
              controls={false}
              muted={true} // Optionally mute if you don't need audio
            />
          </div>
        </div>
      </div>

      {/* about section */}

      <div className="about_section parent bg-img-cover">
        <div className="about_section_cont cont">
          <div className="left ">
            <div className="about_img bg-img-cover"></div>
          </div>
          <div className="right">
            <HeadingTag text="About Jungle Boosh" />
            <h1>Helping India’s Soul Grow Sustainably, Without Leaving Home</h1>
            <p>
              Jungle Bush empowers local farmers, artisans, and creators to grow from their roots, earn with dignity, and build a sustainable future—right from home.
            </p>
            <div className="list">
              <div className="top">
                <div className="icon">
                  <TiArrowForward />
                </div>
                <h4>Together to the future</h4>
              </div>
              <p>
                We believe real progress happens when we move forward together. By supporting rural talent and local products, we’re building a stronger, more connected India—one step at a time.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* steps */}
      <div className="parent step-parent bg-img-cover">
        <div class="border"></div>
        <div className="heading-step-container cont">
          <HeadingTag text="Steps to get online " tag={true} />
        </div>

        <div className="steps-design cont">
          {steps_data.map((item, index) => (
            <div className="cont step-container" key={index} >
              <div className="step-left">
                <img src={item.step_image} alt="" />
              </div>
              <div className="step-right">
                <h3>{item.step_name}</h3>
                <p>{item.steps_contain}</p>
              </div>

              <div className="steps-circle">
                <span className="steps-inner-circle"></span>
              </div>
            </div>
          ))}

          <div className="steps-middle-line"></div>
        </div>
      </div>

      {/* why choose us */}

      <div className="w-c-commonparent">
        <div className="parent why-choose-parent">
          <div className="cont why-choose-container">
            <div className="w-c-left">
              <h2>Why Choose Us</h2>
              {w_c_data.map((item, index) => (
                <div className="w-c-points" key={index} >
                  <div className="tick">{item.logo}</div>
                  <div className="content">
                    <h3>{item.heading} :</h3>
                    <p>{item.des}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-c-right bg-img-cover"></div>
          </div>
          <div className="w-c-right-img bg-img-cover"></div>
        </div>

        <div className="parent elmentor-parent">
          <div className="cont elementor-cont">
            <div className="elementor-element">
              <span>
                <img src={marketing} alt="" />
              </span>
              <h3>Marketing & Promotions</h3>
            </div>

            <div className="elementor-element">
              <span>
                <img src={analysis} alt="" />
              </span>
              <h3>Analytics & Insights</h3>
            </div>

            <div className="elementor-element">
              <span>
                <img src={support} alt="" />
              </span>
              <h3>Dedicated Seller Support</h3>
            </div>
          </div>
        </div>
      </div>

      {/* seller benefits */}
      <div className="parent seller-benefits-parent">
        <div class="border"></div>
        <div className="cont seller-benefits-container">
          <div className="seller-benefits-heading">
            <HeadingTag text="Seller Benefits" tag={true} />
          </div>
          <div className="seller-benefits-bottom">
            <div className="seller-benefits-left">
              {seller_benefits_data.map((item, index) => (
                <div className="seller-benefits-box" key={index}>
                  <img src={item.img} alt="" />
                  <h3 style={{ fontSize: "22px" }}>{item.heading}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
            <div className="seller-benefits-right">
              <div className="seller_benefit_img bg-img-cover"></div>
              <div className="contain">
                <h2>We help our seller achieve their goals!!</h2>
                <p>
                  We help our clients achieve their goals!! Trust Score 4.7
                  (Based on 1,200 reviews)
                </p>
                <Link to="/register" className="border-btn btn-seller">Register</Link>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* testimonial */}
      <div className="parent testimonial-parent bg-img-cover">
        <div className="cont testimonial-container">
          <div className="testimonial-heading">
            <HeadingTag text="Testimonial" />
          </div>
          <div className="testimonial-bottom">
            {testimonial_data.map((item, index) => (
              <div className="testimonial-box" key={index} >
                <div className="testimonial-top">
                  {" "}
                  <span>{item.icon}</span>
                  <p>{item.des}</p>
                </div>
                <div className="testimonial-bottom-img">
                  <div
                    className="testimonial-image bg-img-cover"
                    style={{ background: `url(${item.image})` }}
                  ></div>
                  <div className="name-designation">
                    <h4>{item.name}</h4>
                    <span>{item.city}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>


      {/* bring business online */}
      <div className="parent business-online-parent">
        <div className="cont business-online-container ">
          <div className="top-content">
            <h2>Scale Online Business</h2>
          </div>
          <div className="bottom-content">
            <div className="elementor-wrapper">
              <div className="no">01</div>
              <div className="elements">
                <img src={product_listing} alt="" />
                <div className="element-content">
                  <p>Optimize product listings for maximum visibility</p>
                </div>
              </div>
            </div>

            <div className="elementor-wrapper">
              <div className="no">02</div>
              <div className="elements">
                <img src={strategy} alt="" />
                <div className="element-content">
                  <p>Use smart pricing strategies to boost sales</p>
                </div>
              </div>
            </div>

            <div className="elementor-wrapper">
              <div className="no">03</div>
              <div className="elements">
                <img src={marketing_tool} alt="" />
                <div className="element-content">
                  <p>Leveraging The Jungle Boosh marketing tools</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* footer */}

      <Footer />
    </>
  );
}

export default SellerHome;
